import { marked } from 'marked';

export default class Markdown {
  constructor(el) {
    console.log(this);
    this.content = el.innerHTML;
    this.el = el;
    this.parseMarkdown();
  }

  parseMarkdown() {
    this.el.innerHTML = marked.parse(this.content);
  }
}
